import { selectGameTrackingClientFunnelData, selectGameTrackingDesktopDeviceInformation, selectGameTrackingFeedback, selectGameTrackingFpsAndMemoryUsage, selectGameTrackingPaymentShopClick, selectGameTrackingShopData, selectShopStepName, } from "../../selectors/selectGameTrackingData";
import { actionNoOp } from "./no-op/actionNoOp";
var Spine = PIXI.spine.Spine;
export var TypeActionGameTracking;
(function (TypeActionGameTracking) {
    TypeActionGameTracking["UpdateTracking"] = "GameTracking > UpdateTracking";
})(TypeActionGameTracking || (TypeActionGameTracking = {}));
export var actionGameTrackingUpdateClientFunnel = function (gameState) { return ({
    getData: function (state) { return selectGameTrackingClientFunnelData(state, gameState); },
    logMessage: "ClientFunnel " + gameState,
    trackingName: "ClientFunnel",
    type: TypeActionGameTracking.UpdateTracking,
}); };
export var actionGameTrackingUpdateShop = function (shopState, shopStateData) { return ({
    getData: function (state) { return selectGameTrackingShopData(state, shopState, shopStateData); },
    logMessage: selectShopStepName(shopState, shopStateData),
    trackingName: "Shop",
    type: TypeActionGameTracking.UpdateTracking,
}); };
export var actionGameTrackingUpdateUpdatePaymentShopClick = function (shopOpenSource) { return ({
    getData: function (state) { return selectGameTrackingPaymentShopClick(state, shopOpenSource); },
    logMessage: "Payment Shop " + shopOpenSource,
    trackingName: "Payment Shop",
    type: TypeActionGameTracking.UpdateTracking,
}); };
export var actionGameTrackingUpdateFps = function (fpsEventName) {
    if (Spine.globalAutoUpdate) {
        return {
            getData: function (state) { return selectGameTrackingFpsAndMemoryUsage(state, fpsEventName); },
            logMessage: "Fps " + fpsEventName,
            trackingName: "Fps-" + fpsEventName,
            type: TypeActionGameTracking.UpdateTracking,
        };
    }
    return actionNoOp();
};
export var actionTrackingSendFeedback = function (message) { return ({
    getData: function (state) { return selectGameTrackingFeedback(state, message); },
    logMessage: "Feedback " + message,
    trackingName: "Feedback",
    type: TypeActionGameTracking.UpdateTracking,
}); };
export var actionTrackingSendDesktopDeviceInformation = function () { return ({
    getData: function (state) { return selectGameTrackingDesktopDeviceInformation(); },
    logMessage: "DesktopDeviceInformation",
    trackingName: "Desktop device",
    type: TypeActionGameTracking.UpdateTracking,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/actionGameTracking.ts
// module id = 71
// module chunks = 3